import { Component, OnInit, Inject } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { sessionStorage } from 'src/app/localstorage.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import * as moment from 'moment';
import { DialogComponent } from '../dialog.component';

@Component({
  selector: 'app-redeem-status-modal',
  templateUrl: './redeem-status-modal.component.html',
  styleUrls: ['./redeem-status-modal.component.scss']
})
export class RedeemStatusModalComponent implements OnInit {
  savingFlag: boolean = false;
  segment: any = {};
  category: any = {};
  selected_image: any;
  login: any = {};
  image = new FormData();
  image_id: any;
  drlist: any = []
  delivery_from: any;
  userData: any;
  userId: any;
  userName: any;
  errorMsg: boolean = false;
  today_date: any;
  pendingRedeem: any;
  approvedRedeem: any;
  Scanpoints: any;
  otherWalletpoints: any;
  otpFlag: boolean = false;


  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialog: MatDialog, public serve: DatabaseService, public session: sessionStorage, public toast: ToastrManager, public alert: DialogComponent, public dialogRef: MatDialogRef<RedeemStatusModalComponent>) {
    this.userData = JSON.parse(localStorage.getItem('st_user'));
    this.today_date = new Date();

    console.log('====================================');
    console.log(data, 'data');
    console.log('====================================');
    this.segment = this.data.segment;
    this.userId = this.userData['data']['id'];
    this.userName = this.userData['data']['name'];
    this.delivery_from = this.data.delivery_from;
    console.log(this.delivery_from);



    if (this.data.delivery_from != 'redeem_status') {
      this.getSalesUser('')
      this.distributorList('', '');

    }

    if (this.data.delivery_from == 'redeem_status') {
      this.data.order_status = this.data.gift_status;
      this.getUserEarnPoints();
    }


  }

  ngOnInit() {
    this.login = JSON.parse(localStorage.getItem('login'));
  }
  reason_reject: any
  redeem_status_change(reason, status) {
    this.savingFlag = true;
    this.serve.post_rqst({ 'status': status, 'id': this.data.id, 'created_by_id': this.userId, 'created_by_name': this.userName, 'reject_reason': reason }, "RedeemRequest/redeemRequestStatusChange").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.dialogRef.close(true);
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }

    }))

  }


  updateNumber() {
    this.savingFlag = true;
    this.serve.post_rqst({ 'wallet_number': this.data.wallet_number, 'id': this.data.id, 'created_by_id': this.userId, 'created_by_name': this.userName }, "RedeemRequest/saveWalletNumber").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.dialogRef.close(true);
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }

    }))

  }




  salesUser: any = [];
  getSalesUser(searcValue) {
    this.serve.post_rqst({ 'search': searcValue }, "influencer/salesUserList").subscribe((response => {

      if (response['statusCode'] == 200) {
        this.salesUser = response['all_sales_user'];
      }
      else {
        this.toast.errorToastr(response['statusMsg']);
      }

    }));
  }
  distributorList(searcValue, state) {
    this.serve.post_rqst({ 'search': searcValue, 'state': state }, "influencer/distributorsList").subscribe((result => {
      if (result['statusCode'] == 200) {
        this.drlist = result['distributors'];
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
      }

    }))
  }
  influencer_status_change(reason, status) {
    this.savingFlag = true;
    if (status == 'Approved') {
      this.alert.confirm('Are you sure ?').then((result) => {
        if (result) {
          this.serve.post_rqst({ 'status': status, 'influencer_id': Number(this.data.id), 'welcome_bonus_flag': Number(this.data.welcome_bonus_flag), 'created_by': Number(this.userId), 'distributor_id': this.data.distributor_id, 'referred_by': this.data.referred_by_id, 'name': this.data.name, 'influencer_type': this.data.influencer_type }, "Influencer/influencerStatusChange").subscribe((result => {
            if (result['statusCode'] == 200) {
              this.dialogRef.close(true);
              this.savingFlag = false;
              this.toast.successToastr('Status Changed Successfully');
            }
            else {
              this.toast.errorToastr(result['statusMsg']);
              this.savingFlag = false;
            }

          }))
        }
      });
    } else {
      this.serve.post_rqst({ 'status': status, 'influencer_id': Number(this.data.id), 'welcome_bonus_flag': Number(this.data.welcome_bonus_flag), 'created_by': Number(this.userId), 'reject_reason': reason, 'referred_by': this.data.referred_by_id, 'name': this.data.name, 'influencer_type': this.data.influencer_type }, "Influencer/influencerStatusChange").subscribe((result => {

        if (result['statusCode'] == 200) {
          this.dialogRef.close(true);
          this.savingFlag = false;
          this.toast.successToastr('Status Changed Successfully');
        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.savingFlag = false;
        }

      }))
    }
  }


  gift_status_change(header) {
    this.serve.post_rqst(header, 'RedeemRequest/redeemRequestGiftStatusChange').subscribe((result => {
      if (result['statusCode'] == 200) {
        this.dialog.closeAll();
        this.savingFlag = false;
        this.toast.successToastr(result['statusMsg']);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }
    }))
  }

  updateStatus(status) {
    this.data.estimate_date = moment(this.data.estimate_date).format('YYYY-MM-DD')
    this.data.transfer_date = moment(this.data.transfer_date).format('YYYY-MM-DD')
    this.savingFlag = true;
    let header = {}
    if (status == 'Under Process' || status == 'Received') {
      header = { 'status': status, 'id': this.data.id }
      this.gift_status_change(header)
    } else if (status == 'Shipped') {

      header = { 'status': status, 'id': this.data.id, 'shipping_remark': this.data.Shipped_remark, 'shipping_type': this.data.shipping_type, 'estimate_date': this.data.estimate_date, 'track_id': this.data.track_id }
      this.gift_status_change(header)
    } else if (status == 'Transferred') {
      this.dialogRef.close(this.data,);

      // if (this.data.transfer_mode == 'Online') {
      //   header = { 'status': status, 'id': this.data.id, 'payment_mode': this.data.transfer_mode, 'transfer_date': this.data.transfer_date, "transfer_remark": this.data.transfer_remark }
      //   this.gift_status_change(header)
      // } else if (this.data.transfer_mode == 'Online') {

      // }
    }
  }

  getUserEarnPoints() {
    this.serve.post_rqst({ 'influencer_id': this.userId }, "Influencer/getRedeemreport").subscribe((response => {
      console.log(response);
      if (response['statusCode'] == 200) {
        this.pendingRedeem = response['pending_points']['pendind_point'];
        this.approvedRedeem = response['approved_points']['approved_point'];
        this.Scanpoints = response['Scan_points']['scan_points'];
        this.otherWalletpoints = response['referral_points']['referral_point'];
      }
      else {
        this.toast.errorToastr(response['statusMsg']);
      }

    }));
  }


  purchase_status_change(status, reason) {
    this.savingFlag = true;
    if (status == 'Approved') {
      this.alert.confirm('Are you sure Transfer ?' + this.data.transfer_point + ' Point').then((result) => {
        if (result) {
          this.serve.post_rqst({ 'status': status, 'status_reason': reason, 'influencer_id': Number(this.data.influencerId), 'id': Number(this.data.id), 'created_by': Number(this.userId), 'influencer_type': this.data.influencerType, 'transfer_point': this.data.transfer_point, 'unique_invoice_no': this.data.unique_invoice_no, 'purchaseData': this.data.purchaseData }, "RetailerRequest/purchaseStatusChange").subscribe((result => {
            if (result['statusCode'] == 200) {
              this.dialogRef.close(true);
              this.savingFlag = false;
              this.toast.successToastr('Status Changed Successfully');
            }
            else if (result['statusCode'] == 500) {
              this.toast.errorToastr(result['case']['msg']);
              this.savingFlag = false;

            }
            else {
              this.toast.errorToastr(result['statusMsg']);
              this.savingFlag = false;
            }

          }))
        }
        else {
          this.savingFlag = false;

        }
      });

    }


    else {
      this.serve.post_rqst({ 'status': status, 'influencer_id': Number(this.data.influencerId), 'id': Number(this.data.id), 'created_by': Number(this.userId), 'influencer_type': this.data.influencerType, 'status_reason': reason, 'purchaseData': this.data.purchaseData }, "RetailerRequest/purchaseStatusChange").subscribe((result => {

        if (result['statusCode'] == 200) {
          this.dialogRef.close(true);
          this.savingFlag = false;
          this.toast.successToastr('Status Changed Successfully');

        }
        else {
          this.toast.errorToastr(result['statusMsg']);
          this.savingFlag = false;
        }

      }));
    }



  }


  purchase_remark_update(status, reason) {
    this.savingFlag = true;

    this.serve.post_rqst({ 'id': Number(this.data.id), 'created_by': Number(this.userId),'influencer_id': Number(this.data.influencerId), 'influencer_type': this.data.influencerType, 'status_reason': reason, 'purchaseData': this.data.purchaseData }, "RetailerRequest/purchaseremarkUpdate").subscribe((result => {

      if (result['statusCode'] == 200) {
        this.dialogRef.close(true);
        this.savingFlag = false;
        this.toast.successToastr('Status Changed Successfully');

      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }

    }));
  }







UpdateAttendenceData() {
  this.savingFlag = true;
  this.serve.post_rqst({ 'attendance_id': this.data.id, 'user_id': this.data.user_id, 'working_type': this.data.working_type }, "Attendance/updateAttendanceType").subscribe((result => {
    if (result['statusCode'] == 200) {
      this.dialog.closeAll();
      this.savingFlag = false;
      this.toast.successToastr(result['statusMsg']);

    }
    else {
      this.toast.errorToastr(result['statusMsg']);
      this.savingFlag = false;
    }


  }))
}



getOtp(status) {
  this.data.verify_otp = Math.floor(100000 + Math.random() * 900000);
  this.serve.post_rqst({ 'id': Number(this.data.id), 'status': status, 'otp': this.data.verify_otp }, "RetailerRequest/generate_otp").subscribe((result => {
    if (result['statusCode'] == 200) {
      this.otpFlag = true;
    }
    else {
      this.toast.errorToastr(result['statusMsg'])
    }

  }))

}


otpvalidation() {
  if (this.data.otp.length == 6) {
    if (this.data.otp != this.data.verify_otp) {
      this.toast.errorToastr('Invaild OTP');
    }
  }
}





onUploadChange(data: any) {
  this.errorMsg = false;
  this.image_id = '';
  for (let i = 0; i < data.target.files.length; i++) {
    let files = data.target.files[i];
    if (files) {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.selected_image = e.target.result
      }
      reader.readAsDataURL(files);
    }
    this.image.append("" + i, data.target.files[i], data.target.files[i].name);
  }
}



MobileNumber(event: any) {
  const pattern = /[0-9\+\-\ ]/;
  let inputChar = String.fromCharCode(event.charCode);
  if (event.keyCode != 8 && !pattern.test(inputChar)) { event.preventDefault(); }
}


edit_invoice(unique_invoice_no) {
  this.savingFlag = true;
  this.serve.post_rqst({ 'id': Number(this.data.id), 'unique_invoice_no': unique_invoice_no }, "RetailerRequest/update_unique_invoice_no").subscribe((result => {
    if (result['statusCode'] == 200) {
      this.toast.successToastr('Updated');

      this.dialogRef.close(true);
      this.savingFlag = false;
    }
    else {
      this.toast.errorToastr(result['statusMsg'])
      this.savingFlag = false;

    }

  }))
}

checkin_verification(status, reason) {
  this.savingFlag = true;
  this.serve.post_rqst({ 'status': status, 'id': this.data.id, 'verification_status': status, 'verification_remark': reason }, "Attendance/updateCheckinVerification").subscribe((result => {
    if (result['statusCode'] == 200) {
      this.dialogRef.close(true);
      this.savingFlag = false;
      this.toast.successToastr(result['statusMsg']);
    }
    else {
      this.toast.errorToastr(result['statusMsg']);
      this.savingFlag = false;
    }

  }))

}

}
